function showToast (msg, duration) {
  duration = isNaN(duration) ? 3000 : duration
  const m = document.createElement('div')
  m.innerHTML = msg
  m.style.cssText = 'width:200px; background: #F56C6C; opacity: .9; height:auto; min-height: 50px; color:#fff; line-height:60px; text-align:center; border-radius:4px; position:fixed; top:5%; left:50%; z-index:200; transform: translateX(-50%); font-size: 18px'
  document.body.appendChild(m)
  setTimeout(function () {
    const d = 0.5
    m.style.webkitTransition = '-webkit-transform ' + d + 's ease-in, opacity ' + d + 's ease-in'
    m.style.opacity = '0'
    setTimeout(function () { document.body.removeChild(m) }, d * 1000)
  }, duration)
}

export { showToast }
